import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ConversationEvent,
  FAILED_MESSAGE_PREFIX,
  isMessageEvent,
  MessageEvent,
  PENDING_MESSAGE_PREFIX,
  WebChatAgentTypingIndicatorEvent,
} from '@ucc/cc-common-ui';

import { CorrolatedMessageEvent } from './types';

const conversationEvents = createSlice({
  initialState: [] as ConversationEvent[],
  name: 'conversationEvents',
  reducers: {
    setEvents: (_, { payload }: PayloadAction<ConversationEvent[]>) => payload,
    addEvent: (state, { payload }: PayloadAction<ConversationEvent>) => [payload, ...state],
    removeEvent: (state, action: PayloadAction<MessageEvent>) =>
      state.filter(event => event.id !== action.payload.id),
    failMessageEvent: (state, action: PayloadAction<MessageEvent>) => {
      const messageEvent = state.find(
        message => isMessageEvent(message) && message.id === action.payload.id
      );
      if (messageEvent) {
        messageEvent.id = messageEvent.id.replace(PENDING_MESSAGE_PREFIX, FAILED_MESSAGE_PREFIX);
      }
    },
    mergeMessageEvent: (state, action: PayloadAction<CorrolatedMessageEvent>) => {
      let found = false;
      state.forEach(event => {
        if (
          isMessageEvent(event) &&
          (event.id.startsWith(PENDING_MESSAGE_PREFIX) ||
            event.id.startsWith(FAILED_MESSAGE_PREFIX)) &&
          (event.id.replace(PENDING_MESSAGE_PREFIX, '').replace(FAILED_MESSAGE_PREFIX, '') ===
            action.payload.correlationId ||
            event.body === action.payload.body)
        ) {
          found = true;
          event.id = action.payload.id;
          event.createdAt = action.payload.createdAt;
          event.from = action.payload.from;
          event.associatedFiles = action.payload.associatedFiles;
        }
      });
      if (!found) {
        addEvent(action.payload);
      }
    },
  },
});

export const agentTypingIndicator = createSlice({
  initialState: null as WebChatAgentTypingIndicatorEvent,
  name: 'agentTypingIndicator',
  reducers: {
    setTypingIndicator: (_, { payload }: PayloadAction<WebChatAgentTypingIndicatorEvent>) =>
      payload,
  },
});

export const { setEvents, addEvent, removeEvent, failMessageEvent, mergeMessageEvent } =
  conversationEvents.actions;

export default conversationEvents.reducer;
